<template>
    <v-container>
        <v-skeleton-loader
            v-if="!periods"
            type="list-item@3"
        ></v-skeleton-loader>

        <div v-else>
            <create-period @created="updateData"></create-period>

            <v-row>
                <v-col>
                    <v-combobox
                        v-model="selectedServiceFilter"
                        multiple
                        label="Filter Layanan"
                        :items="services"
                        prepend-icon="mdi-apps"
                    ></v-combobox>
                </v-col>
                <v-col>
                    <v-combobox
                        v-model="selectedSort"
                        :items="sorts"
                        label="Urutkan"
                        prepend-icon="mdi-sort-variant"
                    ></v-combobox>
                </v-col>
            </v-row>

            <v-list elevation="1">
                <v-list-item
                    v-for="period in sortedFilteredPeriods"
                    :key="period.id"
                    :to="{
                        name: 'period.detail',
                        params: { period_id: period.id },
                    }"
                >
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ period.title }}

                            <template v-if="period.is_trial">(Trial)</template>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            <v-icon
                                v-if="!period.is_content_registration"
                                small
                            >
                                mdi-file-question
                            </v-icon>

                            <v-icon
                                v-if="period.has_content"
                                small
                            >
                                mdi-text
                            </v-icon>

                            <v-icon
                                v-if="period.kelon_group_id"
                                small
                            >
                                mdi-play
                            </v-icon>
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </v-list-item>
            </v-list>
        </div>
    </v-container>
</template>

<script>
import CreatePeriod from './components/CreatePeriod'

export default {
    components: {
        CreatePeriod,
    },

    data() {
        return {
            tab: null,
            periods: null,
            selectedServiceFilter: [],
            selectedSort: { text: 'Terbaru', value: 'newest' },
            services: [
                { text: 'Tryout', value: 'tryout' },
                { text: 'Konten', value: 'content' },
                { text: 'Kelon', value: 'kelon' },
            ],
            sorts: [
                { text: 'Terbaru', value: 'newest' },
                { text: 'Tertua', value: 'oldest' },
                { text: 'A-Z', value: 'alpha_asc' },
                { text: 'Z-A', value: 'alpha_desc' },
            ],
        }
    },

    computed: {
        filteredPeriods() {
            if (this.selectedServiceFilter.length == 0) {
                return this.periods
            }

            return this.periods.filter((period) => {
                for (const filter of this.selectedServiceFilter) {
                    if (
                        filter.value == 'tryout' &&
                        period.is_content_registration
                    ) {
                        return false
                    }

                    if (filter.value == 'content' && !period.has_content) {
                        return false
                    }

                    if (filter.value == 'kelon' && !period.kelon_group_id) {
                        return false
                    }
                }

                return true
            })
        },

        sortedFilteredPeriods() {
            return Array.from(this.filteredPeriods).sort((a, b) => {
                switch (this.selectedSort.value) {
                    case 'newest':
                        return a.id == b.id ? 0 : a.id < b.id ? 1 : -1
                    case 'oldest':
                        return a.id == b.id ? 0 : a.id < b.id ? -1 : 1
                    case 'alpha_asc':
                        return a.title == b.title
                            ? 0
                            : a.title.toLowerCase() < b.title.toLowerCase()
                            ? -1
                            : 1
                    case 'alpha_desc':
                        return a.title == b.title
                            ? 0
                            : a.title.toLowerCase() < b.title.toLowerCase()
                            ? 1
                            : -1
                }
            })
        },
    },

    methods: {
        updateData() {
            this.$api.get('period').then((response) => {
                this.periods = response.data.periods
            })
        },
    },

    created() {
        this.updateData()
    },
}
</script>
